import axios from '@/api/requests/axios'

export default {
  getAll: params => axios.get('/api/admin/v1/workflows', { params }),
  getSummary: () => axios.get('/api/admin/v1/workflows/summary'),

  terminateStale: () => axios.post('/api/admin/v1/workflows/terminate-stale'),
}
